<template lang="html">

    <div class="idioma-edit row-start">

        <button class="erase" @click="erase"></button>

        <div class="contenedor-input -xs">
            <label for="">Idioma</label>
            <select v-model="idioma.idIdioma" v-validate="'required'"
                name="idioma" @change="emit" :disabled="!!idioma.id">
                <option value="">Selecciona un idioma</option>
                <option :value="idioma[0]" v-for="idioma in dominios.idiomas">{{idioma[1]}}</option>
            </select>
            <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('idioma') }}</span>

        </div>

        <div class="contenedor-input -xs">
            <label for="">Nivel</label>
            <select v-model="idioma.idNivel" name="nivel"
                v-validate="'required'" @change="emit">
                <option value="">Selecciona un nivel</option>
                <option :value="idioma[0]" v-for="idioma in
                    dominios.nivelesIdioma">{{idioma[1]}}</option>
            </select>
            <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('nivel') }}</span>
        </div>

        <div class="contenedor-check -input -xs" :certificado="idioma.certificacion">
            <input v-model="idioma.certificacion" type="checkbox"
                :id="'idioma-'+idioma.id" @change="emit">
            <label :for="'idioma-'+idioma.id">Con certificado</label>
        </div>

        <div class="contenedor-input -xs" v-if="idioma.certificacion">
            <label for="">Nombre del certíficado</label>
            <input v-model="idioma.descripcionCertificacion" type="text"
                @blur="emit">
        </div>

    </div>

</template>

<script lang="js">

    import {mapGetters, mapActions} from 'vuex';


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

    export default {
        name: 'idioma-edit',
        props : ['data','new'],
        data() {
            return {
                clicked : false,
                idioma: {
                    id: "",
                    idIdioma: "",
                    idNivel: "",
                    certificacion: null,
                    otro: "",
                    descripcionCertificacion: "",
                }
            }
        },
        mounted(){
            if(!!!this.new){
                for(let i in this.data){
                    this.idioma[i] = this.data[i];
                }
                this.idioma.certificacion = (!!this.data.descripcionCertificacion);
            }
        },
        computed : {
            ...mapGetters({
                dominios : 'getDominiosOrder'
            })
        },
        methods : {
            ...mapActions(['editIdioma','eraseIdioma']),
            emit(){
                this.$validator.validateAll()
                .then(itsOk => {
                    if (itsOk) {
                        if(!!!this.new){
                            this.editIdioma(this.idioma);
                        }else{
                            this.$emit('input', this.idioma);
                        }
                    }
                });
            },
            erase(){
                if(!this.new){
                    this.eraseIdioma(this.idioma);
                }else{
                    this.$emit('erase', this.idioma.idIdioma);
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/idioma-edit.vue